export const SERVICES = [
  {
    id: "network-engineering",
    title: "Network Engineering",
    short: "Resilient routing, switching, and segmentation for enterprise networks.",
    icon: "Network",
    items: [
      "Routing & switching architecture",
      "WAN/LAN design and migration",
      "Site-to-site & remote VPN",
      "Network segmentation (VLAN/VRF)",
      "Packet capture & deep analysis",
      "Performance troubleshooting",
    ],
  },
  {
    id: "cybersecurity-consulting",
    title: "Cybersecurity Consulting",
    short: "Firewall strategy, Zero Trust segmentation, and threat mitigation.",
    icon: "Shield",
    items: [
      "Firewall strategy & policy review",
      "Perimeter & internal defense",
      "Access control & identity hardening",
      "Zero Trust-aligned segmentation",
      "Threat mitigation & containment",
      "Incident response support",
    ],
  },
  {
    id: "wifi-infrastructure",
    title: "Wi-Fi & Wireless Infrastructure",
    short: "Wireless design, site surveys, and resilient coverage built to scale.",
    icon: "Wifi",
    items: [
      "Wireless design & site surveys",
      "Controller & access point deployment",
      "Secure SSID & guest network strategy",
      "RF optimization & interference analysis",
      "Roaming & high-density tuning",
      "Wireless troubleshooting & remediation",
    ],
  },
  {
    id: "systems-maintenance",
    title: "Systems Maintenance",
    short: "Linux, VMware, patching, and operational support that doesn't sleep.",
    icon: "Server",
    items: [
      "Linux server administration",
      "VMware virtualization support",
      "Patching, upgrades & lifecycle",
      "Monitoring & alerting",
      "Operational documentation",
      "Run-book & change management",
    ],
  },
  {
    id: "compliance-readiness",
    title: "Compliance & Security Readiness",
    short: "Audit preparation and best-practice alignment for regulated workloads.",
    icon: "ClipboardCheck",
    items: [
      "Documentation & evidence support",
      "Change-control alignment",
      "Access review & least-privilege",
      "Audit preparation workshops",
      "Risk reduction roadmaps",
      "Best-practice gap analysis",
    ],
  },
  {
    id: "training-knowledge-transfer",
    title: "Training & Knowledge Transfer",
    short: "Bring internal IT teams up to speed on the platforms they actually run.",
    icon: "GraduationCap",
    items: [
      "Cisco training & workshops",
      "Juniper training & workshops",
      "Palo Alto training & workshops",
      "VMware training & workshops",
      "Linux training & workshops",
      "Custom team enablement programs",
    ],
  },
];

export const INDUSTRIES = [
  { name: "Small Businesses", icon: "Store", desc: "Right-sized network & security foundations." },
  { name: "Startups", icon: "Rocket", desc: "Scalable infrastructure that grows with you." },
  { name: "Enterprises", icon: "Building2", desc: "Multi-site connectivity and segmentation at scale." },
  { name: "Government Contractors", icon: "ShieldCheck", desc: "Controlled environments with audit-ready posture." },
  { name: "Healthcare", icon: "HeartPulse", desc: "Secure connectivity for sensitive workloads." },
  { name: "Finance", icon: "Landmark", desc: "Hardened perimeters and rigorous access control." },
  { name: "Compliance-Focused Orgs", icon: "FileCheck2", desc: "Documentation-grade engineering practices." },
  { name: "Public Sector Partners", icon: "Briefcase", desc: "Mission-critical operations support." },
];

// Brand pillars — shown on Home.
export const PILLARS = [
  { name: "Secure", tagline: "By Design", icon: "ShieldCheck", desc: "Security decisions baked into every layer — not retrofitted." },
  { name: "Focused", tagline: "On Protection", icon: "Crosshair", desc: "Perimeter, endpoints, identity — we prioritize what threats actually target." },
  { name: "Connected", tagline: "To What Matters", icon: "Share2", desc: "Reliable segmentation and connectivity across sites, users, and workloads." },
  { name: "Trusted", tagline: "Every Step", icon: "Lock", desc: "Documented changes, audit-ready posture, and long-term operational discipline." },
];

// High-level practice areas shown publicly.
export const EXPERTISE = [
  {
    name: "Networking",
    icon: "Network",
    desc: "Routing, switching, WAN/LAN, segmentation, and deep troubleshooting across enterprise environments.",
  },
  {
    name: "Cybersecurity",
    icon: "Shield",
    desc: "Firewall strategy, Zero Trust-aligned segmentation, access control, and threat mitigation.",
  },
  {
    name: "Wi-Fi",
    icon: "Wifi",
    desc: "Wireless design, site surveys, secure SSIDs, and resilient coverage for offices and distributed campuses.",
  },
  {
    name: "Training",
    icon: "GraduationCap",
    desc: "Hands-on training and knowledge transfer across Cisco, Juniper, Palo Alto, VMware, and Linux.",
    platforms: ["Cisco", "Juniper", "Palo Alto", "VMware", "Linux"],
  },
];

export const COMPANY = {
  name: "bekTech",
  email: "contact@bektechnology.com",
  emailSecondary: "bekim@bektechnology.com",
  phone: "703-203-4949",
  phoneHref: "tel:+17032034949",
  website: "bektechnology.com",
  websiteUrl: "https://bektechnology.com",
  tagline: "Network & Cybersecurity Consulting",
  logoUrl: "/bektech-logo.jpg",
  logoRasterUrl: "/bektech-logo.jpg",
};
